(function () {
  class FairyMultiplierView extends PIXI.Container {
    constructor() {
      super();
      this.initialised = false;
      this.multiplierActive = false;
      this._fairyAnimContainer = null;
      this._fairyAnim = null;

      const self = this;

      StateMachine.Create(this);

      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState("IDLE", function () {});
      this.stateMachine.addState("INITIALMULTIPLIER", function () {
        self.updateInitialMultiplier();
      });
      this.stateMachine.addState("INCREASEMULTIPLIER", function () {
        self.updateIncreaseMultiplier();
      });
      this.stateMachine.addState("RESET_MULTIPLIER", function () {
        self.updateResetMultiplier();
      });

      this.resetMultiplierValues();

      this.baseScales = [1, 0.75, 0.5];
      this.lengthScales = [1, 0.74, 0.62, 0.5, 0.38];
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    addMessageListeners() {
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );

      messageBus.subscribe(
        "game:ModifierEvent",
        this.onModifierEvent.bind(this)
      );

      messageBus.subscribe(
        "layoutController:backFromReplay",
        this.backFromReplay.bind(this)
      );
    }

    onLayoutComplete() {
      const baseName = "fairyMultiplierContainer:FairyMultiplierView:";

      // Duplicate
      this.multiplierDuplicate = resourceManager.get(
        baseName + "multiplierDuplicate"
      );
      this.duplicateText = resourceManager.get(
        baseName + "multiplierDuplicate:multiplierDuplicateTextOff"
      );
      this.duplicatePos = {
        x: this.multiplierDuplicate.x,
        y: this.multiplierDuplicate.y,
      };

      // Back
      this.multiplierBack = resourceManager.get(baseName + "multiplierBack");
      this.backText = resourceManager.get(
        baseName + "multiplierBack:multiplierBackTextOff"
      );
      this.backPos = {
        x: this.multiplierBack.x,
        y: this.multiplierBack.y,
      };

      // Mid
      this.multiplierMid = resourceManager.get(baseName + "multiplierMid");
      this.midText = resourceManager.get(
        baseName + "multiplierMid:multiplierMidTextOff"
      );
      this.midPos = { x: this.multiplierMid.x, y: this.multiplierMid.y };

      // Front
      this.multiplierFront = resourceManager.get(baseName + "multiplierFront");

      (this.frontText = resourceManager.get(
        baseName + "multiplierFront:multiplierFrontTextOn"
      )),
        (this.frontPos = {
          x: this.multiplierFront.x,
          y: this.multiplierFront.y,
        });

      this.lanternDoorAnim = resourceManager.get(
        baseName + "lantern:lanternDoor"
      );
      this.lanternDoorAnim.gotoAndStop(14);
      this.lanternBurstAnim = resourceManager.get(
        baseName + "lantern:lanternBurst"
      );
      this.lanternBurstAnim.gotoAndStop(0);
      this.lanternGlow = resourceManager.get(baseName + "lantern:lanternGlow");

      this.setLayoutScaleFactor(this.multipliers);

      this.setupInitialScales();

      this.updateMultiplierText();

      this.addMessageListeners();

      this._fairyAnimContainer = resourceManager.get(
        "fairyMultiplierContainer:FairyMultiplierView:fairyContainer"
      );

      this._fairyAnim = resourceManager.createObject(
        "spine",
        "fairySpine",
        this._fairyAnimContainer,
        {
          name: "FairyAnim",
          defaultAnimation: "Idle",
          scale: 0.7,
        }
      );
      this._fairyAnim.spineObject.state.timeScale = 0.6;

      const DEFAULT_MIX_TIME = 0.2;
      this._fairyAnim.mixAnims("Idle", "Reel Spin", DEFAULT_MIX_TIME);
      this._fairyAnim.mixAnims("Idle", "Throw", DEFAULT_MIX_TIME);
      this._fairyAnim.mixAnims("Idle", "Lantern", DEFAULT_MIX_TIME);

      this._fairyAnim.mixAnims("Idle2", "Reel Spin", DEFAULT_MIX_TIME);
      this._fairyAnim.mixAnims("Idle2", "Throw", DEFAULT_MIX_TIME);
      this._fairyAnim.mixAnims("Idle2", "Lantern", DEFAULT_MIX_TIME);

      this._fairyAnim.mixAnims("Reel Spin", "Throw", DEFAULT_MIX_TIME);
      this._fairyAnim.mixAnims("Reel Spin", "Lantern", DEFAULT_MIX_TIME);
      // below is needed when multiple spins in a row play "Reel Spin" anim - otherwise it looks skippy!
      this._fairyAnim.mixAnims("Reel Spin", "Reel Spin", DEFAULT_MIX_TIME);

      this.playFairyIdle();

      this._fairyParticleContainer = resourceManager.get(
        "fairyMultiplierContainer:FairyMultiplierView:particleContainer"
      );

      this._fairyParticle = particleManager.createEmitter(
        "Glow",
        this._fairyParticleContainer.name,
        0,
        0,
        false
      );
      this._fairyParticle.particleEmitter.emit = false;
      this._fairyParticle.visible = false;
    }

    onModifierEvent(modifierTask) {
      this._modifierTask = modifierTask;
      this._modifierTask.join();
      // modifier.leave() is called in final call of eliminateSymbol() func
      const { eliminatedSymbols } = modifierTask.data;
      const timeoutInterval = 2250;
      for (let i = 0; i < eliminatedSymbols.length; i++) {
        timerManager.addTimeout(timeoutInterval * i, () => {
          this.playFairyThrowAnim(
            eliminatedSymbols[i].reel,
            eliminatedSymbols[i].row,
            i === eliminatedSymbols.length - 1
          );
        });
      }
    }

    resetMultiplierValues() {
      this.multiplierIndex = 1;
      this.multipliers = [1, 2, 4, 8]; // front, middle, back, duplicate
    }

    setLayoutScaleFactor(multipliers) {
      this.frontScale =
        this.baseScales[0] * this.getMultiplierSize(multipliers[0]);
      this.midScale =
        this.baseScales[1] * this.getMultiplierSize(multipliers[1]);
      this.backScale =
        this.baseScales[2] * this.getMultiplierSize(multipliers[2]);
    }

    setupInitialScales() {
      this.multiplierDuplicate.scale.set(0);
      this.multiplierBack.scale.set(this.backScale);
      this.multiplierMid.scale.set(this.midScale);
      this.multiplierFront.scale.set(this.frontScale);

      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale);
    }

    setMultiplierPositions() {
      this.multiplierDuplicate.position.set(
        this.duplicatePos.x,
        this.duplicatePos.y
      );
      this.multiplierBack.position.set(this.backPos.x, this.backPos.y);
      this.multiplierMid.position.set(this.midPos.x, this.midPos.y);
      this.multiplierFront.position.set(this.frontPos.x, this.frontPos.y);
    }

    playFairyIdle() {
      const idleAnim = GLOBALS.getRandom(3) === 1 ? "Idle" : "Idle2";
      this._fairyAnim.play(idleAnim, false, 0, () => {
        this.playFairyIdle();
      });
    }

    playFairyStartAnim() {
      if (GLOBALS.getRandom(3) === 1) {
        this._fairyAnim.play("Reel Spin", false, 0, () => {
          this.playFairyIdle();
        });
      }
    }

    playFairyThrowAnim(reel, row, isFinalElimination) {
      const endPos = this.getSymbolPositionRelativeToParticle(reel, row);

      this._fairyParticle.particleEmitter.emit = true;
      this._fairyParticle.visible = true;

      const FADE_IN_DURATION = 1;
      const MOVE_BACK_DURATION = 0.2;
      const PATH_DURATION = 1;

      // fade in fairy particle
      this._fairyThrowTweenA = gsap.fromTo(
        this._fairyParticle,
        { alpha: 0 },
        {
          alpha: 1,
          duration: FADE_IN_DURATION,
          onComplete: () => {
            this._fairyAnim.play("Throw", false, 0, () => {
              this.playFairyIdle();
            });
            this._fairyParticleTweenA = null;
          },
        }
      );

      // fairy particle path
      this._spiralProgress = 0;
      this._fairyThrowTweenB = gsap
        .timeline()
        // move back particle as fairy hand moves back to throw
        .fromTo(
          this._fairyParticle.particleEmitter.spawnPos,
          { x: 0, y: 0 },
          {
            x: -35,
            y: 55,
            duration: MOVE_BACK_DURATION,
            delay: FADE_IN_DURATION,
            onStart: () => {
              soundManager.play("fairyParticle");
            },
          }
        )
        // move a bit towards end pos
        .to(this._fairyParticle.particleEmitter.spawnPos, {
          x: (3 * (endPos.x - -35)) / 8,
          y: (3 * (endPos.y - 45)) / 8,
          duration: (PATH_DURATION * 2) / 8,
        })
        // do a spiral
        .to(this, {
          _spiralProgress: 100,
          duration: (PATH_DURATION * 2) / 8,
          onUpdate: () => {
            const progress = this._spiralProgress / 100;
            const { x, y } = this.getSpiralPositionAtProgress(
              {
                x: (3 * (endPos.x - -35)) / 8,
                y: (3 * (endPos.y - 55)) / 8,
              },
              {
                x: endPos.x - (3 * (endPos.x - -35)) / 8,
                y: endPos.y - (3 * (endPos.y - 55)) / 8,
              },
              progress
            );
            this._fairyParticle.particleEmitter.spawnPos.x = x;
            this._fairyParticle.particleEmitter.spawnPos.y = y;
          },
        })
        // move a bit up
        .to(this._fairyParticle.particleEmitter.spawnPos, {
          y:
            this._fairyParticle.particleEmitter.spawnPos.y -
            Math.abs((7 * (endPos.y - 55)) / 8),
          duration: (PATH_DURATION * 1) / 8,
        })
        // fall to end position
        .to(this._fairyParticle.particleEmitter.spawnPos, {
          y: endPos.y,
          duration: 3 / 8,
          onComplete: () => {
            this.eliminateSymbol(reel, row, isFinalElimination);
            this._fairyParticle.particleEmitter.emit = false;
            this._fairyParticle.visible = false;
            this._fairyParticle.particleEmitter.pivot = 0;
            this._fairyParticle.particleEmitter.spawnPos.x = 0;
            this._fairyParticle.particleEmitter.spawnPos.y = 0;
            this._fairyParticleTweenB = null;
          },
        });
      this._fairyParticleTweenC = gsap.to(
        this._fairyParticle.particleEmitter.spawnPos,
        {
          x: endPos.x,
          duration: 3 / 8,
          delay:
            FADE_IN_DURATION + MOVE_BACK_DURATION + (PATH_DURATION * 4) / 8,
          onComplete: () => {
            this._fairyParticleTweenC = null;
          },
        }
      );
    }

    getSymbolPositionRelativeToParticle(reel, row) {
      const symbol = resourceManager
        .get(`slotContainer:reelContainer:reel${reel}`)
        .getReelSymbol(row);
      return this._fairyParticle.toLocal(symbol.toGlobal(systemData.stage));
    }

    getSpiralPositionAtProgress(startPos, endPos, progress, turns = 1) {
      const u = progress;

      const dx = endPos.x - startPos.x;
      const dy = endPos.y - startPos.y;

      const distance = Math.hypot(dx, dy);
      const ux = dx / distance;
      const uy = dy / distance;

      const vx = -uy;
      const vy = ux;

      const radius = distance * u;
      const theta = 2 * Math.PI * turns * (1 - u);

      const x =
        startPos.x + radius * (Math.cos(theta) * ux + Math.sin(theta) * vx);
      const y =
        startPos.y + radius * (Math.cos(theta) * uy + Math.sin(theta) * vy);

      return { x, y };
    }

    eliminateSymbol(reel, row, isFinalElimination) {
      gsap.fromTo(
        gameData.reels[reel].getReelSymbol(row),
        { alpha: 1 },
        {
          alpha: 0,
          duration: 1,
        }
      );

      if (isFinalElimination) {
        gameController.fairyBurstAnims[reel][row].onComplete = () => {
          gameController.fairyBurstAnims[reel][row].onComplete = null;
          this._modifierTask.leave();
        };
      }

      gameController.fairyBurstAnims[reel][row].gotoAndPlay(0);
    }

    moveAndScale() {
      const duration = 0.35;
      const newBackScale =
        this.baseScales[2] * this.getMultiplierSize(this.multipliers[3]);
      const newMidScale =
        this.baseScales[1] * this.getMultiplierSize(this.multipliers[2]);
      const newFrontScale =
        this.baseScales[0] * this.getMultiplierSize(this.multipliers[1]);

      // negative speed makes it play frames in reverse
      this.lanternDoorAnim.animationSpeed = -Math.abs(
        this.lanternDoorAnim.animationSpeed
      );
      this.lanternDoorAnim.onComplete = () => {
        this.moveAndScaleComplete();
        this.lanternDoorAnim.onComplete = () => {};
        this.lanternDoorAnim.animationSpeed = Math.abs(
          this.lanternDoorAnim.animationSpeed
        );
        this.lanternDoorAnim.gotoAndPlay(0);
        gsap.to(this.multiplierFront, {
          delay: duration,
          duration,
          alpha: 1,
          onStart: () => {
            this.lanternBurstAnim.gotoAndPlay(0);
            soundManager.play("multiplierIncreased");
          },
        });
        gsap.to(this.multiplierFront.scale, {
          delay: duration,
          duration,
          x: 1,
          y: 1,
        });
        gsap.to(this.lanternGlow, {
          delay: duration,
          duration,
          alpha: 1,
        });
      };
      this.lanternDoorAnim.play();
      this._fairyAnim.play("Lantern", false, 0, () => {
        this.playFairyIdle();
      });

      gsap.to(this.multiplierFront, {
        duration,
        alpha: 0,
      });
      gsap.to(this.multiplierFront.scale, {
        x: 0,
        y: 0,
      });
      gsap.to(this.lanternGlow, {
        alpha: 0,
        duration,
      });
      gsap.to(this.multiplierMid, {
        duration,
        x: this.frontPos.x,
        y: this.frontPos.y,
      });
      gsap.to(this.multiplierMid.scale, {
        duration,
        x: newFrontScale * 0.8,
        y: newFrontScale * 0.8,
      });
      gsap.to(this.multiplierBack, {
        duration,
        x: this.midPos.x,
        y: this.midPos.y,
      });
      gsap.to(this.multiplierBack.scale, {
        duration,
        x: newMidScale,
        y: newMidScale,
      });
      gsap.to(this.multiplierDuplicate, {
        duration,
        x: this.backPos.x,
        y: this.backPos.y,
      });
      gsap.to(this.multiplierDuplicate.scale, {
        duration,
        x: newBackScale,
        y: newBackScale,
      });
    }

    moveAndScaleComplete() {
      this.incrementMultipliers();
      this.updateMultiplierText();
      this.setFinalScaleAndPosition();
      this.onOrientationChange();
    }

    setFinalScaleAndPosition() {
      this.setMultiplierPositions(
        this.frontPos,
        this.midPos,
        this.backPos,
        this.duplicatePos
      );

      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale);
    }

    increaseMultiplier(newMultiplier) {
      if (newMultiplier <= this.multipliers[0]) return;
      this.stateMachine.switchState("INCREASEMULTIPLIER");
    }

    resetMultiplier() {
      if (this.multipliers[0] === 1) return;
      this.stateMachine.switchState("RESET_MULTIPLIER");
    }

    updateMultiplierText() {
      this.frontText.setText("x" + this.multipliers[0]);
      this.midText.setText("x" + this.multipliers[1]);
      this.backText.setText("x" + this.multipliers[2]);
      this.duplicateText.setText("x" + this.multipliers[3]);

      this.setLayoutScaleFactor(this.multipliers);
    }

    setMultiplierScale(frontScale, midScale, backScale) {
      this.multiplierDuplicate.scale.set(0);

      this.multiplierBack.scale.set(backScale);

      this.multiplierMid.scale.set(midScale);

      this.multiplierFront.scale.set(frontScale);
    }

    incrementMultipliers() {
      this.multiplierIndex++;

      let index = this.multiplierIndex;
      for (let i = 0; i <= this.multipliers.length - 1; i++) {
        this.multipliers[i] = Math.pow(2, index - 1);
        index++;
      }
    }

    updateIncreaseMultiplier() {
      if (this.phase.enter()) {
      }

      if (this.phase.once()) {
        this.moveAndScale();
      }

      if (this.phase.timed(1200)) {
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("IDLE");
      }
    }

    updateResetMultiplier() {
      if (this.phase.enter()) {
      }

      if (this.phase.once()) {
        const duration = 0.35;
        this.lanternDoorAnim.animationSpeed = -Math.abs(
          this.lanternDoorAnim.animationSpeed
        );
        this.lanternDoorAnim.onComplete = () => {
          this.lanternDoorAnim.onComplete = () => {};
          this.lanternDoorAnim.animationSpeed = Math.abs(
            this.lanternDoorAnim.animationSpeed
          );
          this.lanternDoorAnim.gotoAndPlay(0);
          gsap.to(this.multiplierFront.scale, {
            duration: 0.15,
            delay: duration,
            x: this.frontScale,
            y: this.frontScale,
            onComplete: () => {
              this.setLayoutScaleFactor(this.multipliers);
              this.setMultiplierScale(
                this.frontScale,
                this.midScale,
                this.backScale
              );
              this.stateMachine.switchState("IDLE");
            },
          });
          gsap.to(this.lanternGlow, { alpha: 1, duration });
          gsap.to(this.multiplierMid.scale, {
            duration: 0.15,
            delay: 0.35,
            x: this.midScale,
            y: this.midScale,
          });
          gsap.to(this.multiplierBack.scale, {
            duration: 0.15,
            delay: 0.35,
            x: this.backScale,
            y: this.backScale,
          });
        };
        this.lanternDoorAnim.play();
        this.multiplierDuplicate.scale = 0;
        gsap.to(
          [
            this.multiplierFront.scale,
            this.multiplierMid.scale,
            this.multiplierBack.scale,
          ],
          {
            duration: 0.15,
            x: 0,
            y: 0,
            onComplete: () => {
              this.resetMultiplierValues();
              this.updateMultiplierText();
            },
          }
        );
        gsap.to(this.lanternGlow, { alpha: 0, duration });
      }
    }

    updateInitialMultiplier() {
      if (this.phase.enter()) {
        this.multiplierActive = true;
      }

      if (this.phase.once()) {
        this.moveAndScale();
      }

      if (this.phase.timed(1200)) {
      }

      if (this.phase.once()) {
        this.setFinalScaleAndPosition();
        this.stateMachine.switchState("IDLE");
      }
    }

    getMultiplierSize(multiplier) {
      if (multiplier < 10) {
        return this.lengthScales[0];
      } else if (multiplier < 100) {
        return this.lengthScales[1];
      } else if (multiplier < 1000) {
        return this.lengthScales[2];
      } else if (multiplier < 10000) {
        return this.lengthScales[3];
      } else {
        return this.lengthScales[4];
      }
    }

    backFromReplay() {
      this.onOrientationChange();
      this.setupInitialScales();
    }

    onOrientationChange() {
      this.frontPos = { x: this.multiplierFront.x, y: this.multiplierFront.y };
      this.midPos = { x: this.multiplierMid.x, y: this.multiplierMid.y };
      this.backPos = { x: this.multiplierBack.x, y: this.multiplierBack.y };
      this.duplicatePos = {
        x: this.multiplierDuplicate.x,
        y: this.multiplierDuplicate.y,
      };

      this.setLayoutScaleFactor(this.multipliers);

      this.setupInitialScales();

      if (this._fairyThrowTweenA != null) {
        this._fairyThrowTweenA.progress(1);
      }
      if (this._fairyThrowTweenB != null) {
        this._fairyThrowTweenB.progress(1);
      }
      if (this._fairyThrowTweenC != null) {
        this._fairyThrowTweenC.progress(1);
      }
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }
  }

  create = function (json) {
    return new FairyMultiplierView();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return ["", ""];
  };

  resourceManager.registerObjectType(
    "FairyMultiplierView",
    create,
    initialise,
    getFilesRequired
  );
})();
